module.exports = __webpack_public_path__ + "static/media/abs.0b30f193.svg";